import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { GuaranteeTypeListService } from '../../service/guarantee-type-list/guarantee-type-list.service';

@Component({
	selector: 'app-guarantee-type-list',
	templateUrl: './guarantee-type-list.component.html',
	providers: [
		GuaranteeTypeListService,
		HttpModule
	]
})
export class GuaranteeTypeListComponent implements OnInit {

	private token;
	public guaranteeTypes: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	guaranteeType: FormGroup;

	constructor(fb: FormBuilder, private guaranteeTypeListService: GuaranteeTypeListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.guaranteeType = fb.group({
			'Nome': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchClientType(this.guaranteeType.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchClientType(this.guaranteeType.value, this.currentPage, false);
	}

	searchClientType(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.guaranteeTypeListService.searchGuaranteeType(this.token, value.Nome, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.guaranteeTypes = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchClientType(this.guaranteeType.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/guarantee-type/component/guarantee-type-list/guarantee-type-list.component.ts